import { Link } from 'react-router-dom';
import { siteConfig, categories, navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-lg font-bold text-background-50 no-underline font-heading mb-4">
              <span className="text-2xl">{siteConfig.logo}</span>
              <span className="whitespace-nowrap">{siteConfig.name}</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteConfig.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors no-underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">视频分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-sm"></i>
                <span>contact@xiangrikui.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-sm"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-sm"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}